import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Fields from './Fields';
import { newBadge } from 'services/badge.routes';
import { toast } from 'react-toastify';
import { updateBadge } from 'services/badge.routes';
import imageCompression from 'browser-image-compression';

export default function NewBadge() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    const schema = yup.object().shape({
        name: yup.string().required(),
        category_id: yup.string().required(),
    });

    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                category_id: state.category_id,
            });
        }
    }, [state]);

    const handleNewBadge = () => {
        schema.validate(information)
            .then(async (res) => {
                if (res) {
                    const formdata = await handleFormData(information);
                    setLoading(true);
                    newBadge(formdata, (isOk, data) => {
                        setLoading(false)
                        if (!isOk) {
                            return toast.error(data.message);
                        } else {
                            toast.success(`نشان اضافه شد`);
                            navigate('/badge')
                        }
                    });
                }
            }).catch(err => {
                return toast.error(err.errors[0])
            })
    }

    const handleUpdateBadge = async () => {
        if (state.id) {
           const formdata = await handleFormData(information);
            setLoading(true);
            updateBadge(state.id, formdata, (isOk, data) => {
                setLoading(false)
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    toast.success(`نشان ویرایش شد`);
                    navigate('/badge')
                }
            });
        }
    }
    const handleFormData = async (info) => {
        let formdata = new FormData();
        const { icon, ...restInformation } = info;
        for (let item in restInformation) {
            if (restInformation[item]) formdata.append(item, restInformation[item]);
        }
        if (icon && icon.length > 0 && icon[0] instanceof File) {
            const compressedImage = await imageCompression(icon[0], { maxSizeMB: 2 });
            formdata.append("icon", compressedImage);
        }
        return formdata;
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <p style={{ fontSize: 16, fontWeight: "bold" }}>{method !== "update" ? "نشان جدید" : "ویرایش نشان"}</p>
            <Fields information={information} handleUpdate={handleUpdateBadge} method={method} setInformation={setInformation} submit={handleNewBadge} />
        </DashboardLayout>
    )
}
